var exports = {
  "zr": "DamaBoard.module__root___NDJQcl",
  "no": "DamaBoard.module__board___NDJQcl",
  "Ew": "DamaBoard.module__square___NDJQcl",
  "BB": "DamaBoard.module__light___NDJQcl",
  "XT": "DamaBoard.module__dark___NDJQcl",
  "fV": "DamaBoard.module__piece___NDJQcl",
  "f0": "DamaBoard.module__paths___NDJQcl",
  "r2": "DamaBoard.module__pathsLabel___NDJQcl",
  "Ae": "DamaBoard.module__path___NDJQcl",
  "z3": "DamaBoard.module__error___NDJQcl",
};

module.exports = exports;
